import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large SubmitOrder",
    title: "Создание РПП",
    loading: _ctx.state.is_loading,
    onConfirm: _ctx.emitCreateOrder,
    onCancel: _ctx.emitCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        value: _ctx.state.act_number,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.act_number) = $event)),
        "is-invalid": _ctx.state_form$.act_number.$error,
        "validation-errors": _ctx.state_form$.act_number.$errors,
        placeholder: "Номер АВР"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.act_date,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.act_date) = $event)),
        "is-invalid": _ctx.state_form$.act_date.$error,
        "validation-errors": _ctx.state_form$.act_date.$errors,
        placeholder: "Дата АВР",
        type: "date"
      }, null, 8, ["value", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["loading", "onConfirm", "onCancel"]))
}